import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { useApi } from "src/Api/useApi";
import Page from "src/components/common/Page";
import PageHero from "src/components/common/PageHero";
import AuthContext from "src/context/AuthContext";
import OrgDatasetAccordionItems, {
	OrgDatasetRow,
} from "./OrgDatasetAccordionItems";
import Spinner from "src/components/common/Spinner";

const styles = {
	title: { textAlign: "center" } as const,
	container: {
		display: "flex",
		flex: 1,
		alignItems: "center",
		flexDirection: "column",
		justifyContent: "center",
	} as const,
};

const MultiOrgDatasetListView = () => {
	const { organizationClient, datasetsClient } = useApi();
	const { currentUser } = useContext(AuthContext);
	const [orgDatasetRows, setOrgDatasetRows] = useState<OrgDatasetRow[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		async function loadOrgs() {
			setLoading(true);
			if (organizationClient && currentUser && datasetsClient) {
				try {
					const orgsResponse = await organizationClient.getOrgsForUser(
						currentUser.id
					);
					let orgDatasets: OrgDatasetRow[] = [];
					for (const org of orgsResponse) {
						const datasetResponse = await datasetsClient.getAllLite(org.id);
						orgDatasets.push({ org: org, datasets: datasetResponse });
					}

					// Sort the orgs so that the primary org is on top and the rest are sorted alphabetical below it
					let sortedAlphabetically: OrgDatasetRow[] = [];
					const sortAlphabetically = [...orgDatasets].sort((a, b) => {
						if (a.org.name && b.org.name) {
							return a.org.name.localeCompare(b.org.name);
						}
						return 0;
					});
					sortedAlphabetically.push(...sortAlphabetically);

					const sortedByPrimaryOrg = [...sortedAlphabetically].sort((a, b) => {
						if (a.org.isPrimaryOrg === true && b.org.isPrimaryOrg !== true)
							return -1;
						if (a.org.isPrimaryOrg !== true && b.org.isPrimaryOrg === true)
							return 1;
						return 0;
					});
					setOrgDatasetRows(sortedByPrimaryOrg);
				} catch {
					console.error("error");
				}
			}
		}
		loadOrgs();
	}, []);

	useEffect(() => {
		setLoading(false);
	}, [orgDatasetRows]);

	if (!currentUser) {
		console.error("User is not logged in");
		return null;
	}

	return (
		<Page title="Select a dataset">
			<div style={styles.container}>
				<PageHero>
					<h1 style={styles.title}>Select a Dataset</h1>
				</PageHero>
				{loading ? (
					<Spinner className={"spinner-large"} />
				) : (
					<OrgDatasetAccordionItems
						currentUser={currentUser}
						orgDatasetRows={orgDatasetRows}
					/>
				)}
			</div>
		</Page>
	);
};
export default MultiOrgDatasetListView;
